import { startOfToday } from 'date-fns';
import { Creator, OptimisationSlice } from 'store/types';

export const createOptimisationSlice: Creator<OptimisationSlice> = (set) => ({
  currentDate: startOfToday(),
  setCurrentDate: (currentDate: Date) => set(() => ({ currentDate })),
  mobileCalendarOpen: false,
  mobileProfileOpen: false,
  setMobileCalendarOpen: () => set(() => ({ mobileCalendarOpen: true })),
  setMobileCalendarClosed: () => set(() => ({ mobileCalendarOpen: false })),
  setMobileProfileOpen: () => set(() => ({ mobileProfileOpen: true })),
  setMobileProfileClosed: () => set(() => ({ mobileProfileOpen: false })),
});
